module.exports = {
	container: {
		center: true,
		padding: "10px",
	},
	extend: {
		screens: {
			xs: "400px",
			sm: "640px",
			md: "768px",
			lg: "1024px",
			xl: "1330px",
			"2xl": "1441px",
			"xl-down": {
				max: "1440px",
			},
			"lg-down": {
				max: "1329px",
			},
			"md-down": {
				max: "1023px",
			},
			"sm-down": {
				max: "767px",
			},
			"sm-only": {
				max: "669px",
			},
		},
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			black: "#000000",
			white: "#ffffff",
			primary: "#0075BE",
			navy: "#1C2545",
			orange: "#EE8904",
			yellow: "#FDC652",
			blue: {
				DEFAULT: "#50759C",
				2: "#173B60",
				3: "#83D0F5",
				4: "#D9F3FF",
			},
			grey: {
				DEFAULT: "#6C6F79",
				2: "#9FA1A8",
				3: "#CCD7E2",
			},
		},
		borderRadius: {
			"4xl": "32px",
		},
		margin: {
			container: "15px",
		},
		borderRadius: {
			button: "23px",
		},
		boxShadow: {
			card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
			callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
		},
		keyframes: {
			"hamburger-close-to-open": {
				"0%": {
					"clip-path": "url('/wp-content/themes/device-authority/assets/images/close.svg#clip-path-0')",
					transform: "scale(1)",
				},
				"50%": { transform: "scale(0)" },
				"100%": {
					"clip-path": "url('/wp-content/themes/device-authority/assets/images/open.svg#clip-path-0')",
					transform: "scale(1)",
				},
			},
		},
		animation: {
			"hamburger-active": "hamburger-close-to-open var(--duration) linear forwards",
			"hamburger-inactive": "hamburger-close-to-open var(--duration) linear reverse forwards",
		},
	},
};
